<template lang="pug">

.safe-area-top(ref='container')

</template>

<script>
import QueryString from "query-string"

export default {
  mounted() {
    const { container } = this.$refs

    let safeAreaHeight = -1
    let statusBarHeight = -1

    const qs = QueryString.parse(window.location.search)
    let querySafeAreaHeight = Number(qs.safeAreaHeight)
    let queryStatusBarHeight = Number(qs.statusBarHeight)

    // 带路由的项目：参数在 vue-router 上
    let routeSafeAreaHeight = 0
    let routeStatusBarHeight = 0
    if (this.$route && this.$route.query) {
      routeSafeAreaHeight = Number(this.$route.query.safeAreaHeight)
      routeStatusBarHeight = Number(this.$route.query.statusBarHeight)
    }

    // 确定最终的 barHeight
    statusBarHeight = queryStatusBarHeight || routeStatusBarHeight || 0
    safeAreaHeight = querySafeAreaHeight || routeSafeAreaHeight || 0

    // 如果 url-query(safe-area) 不为零，则为异形屏，使用传入的 safe-area
    if (safeAreaHeight > 0) {
      container.style.height = `${safeAreaHeight}px`
      return
    }

    // 如果 url-query(safe-area) 为零，则为普通屏，使用 url-query(status-bar) 的高度
    if (statusBarHeight > 0) {
      container.style.height = `${statusBarHeight}px`
    }
  }
}
</script>

<style scoped lang="stylus">
.safe-area-top
  height constant(safe-area-inset-top)
  height env(safe-area-inset-top)
</style>
